import { createAsyncAction } from 'src/redux/actions';

export const FetchProjects = createAsyncAction('dashboard/FETCH_PROJECTS');
export const FetchProject = createAsyncAction('dashboard/FETCH_PROJECT');
export const CLEAR_FILTERED_PROJECTS = `dashboard/CLEAR_FILTERED_PROJECTS`;
export const SELECT_PROJECT = `dashboard/SELECT_PROJECT`;
